module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.2b114277.svg";